import { onboardingMessagesActionTypes } from '@/components/onboardingMessages/Constants';

import type { Action } from '@/shared/types';

const initialState = {
	onboardingMessagesType: null,
	onboardingMessagesData: null,
};

export default function onboardingChatReducer(state = initialState, action: Action) {
	const { type, payload } = action;
	const { onboardingMessagesType, onboardingMessagesData } = payload || {};

	switch (type) {
		case onboardingMessagesActionTypes.SET_ONBOARDING_MESSAGES_TYPE:
			return {
				...state,
				onboardingMessagesType,
				onboardingMessagesData,
			};

		default:
			return state;
	}
}
